<template>
    <div class="grid grid-cols-12 gap-6"></div>
</template>

<script>
export default {
    name: 'GameFeedSubpage',

    components: {},

    data() {
        return {}
    },

    computed: {},

    created() {},

    methods: {},
}
</script>
